import React from 'react'

function InfoIcon(): JSX.Element {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM16.5 10.95H13.5V8.25H16.5V10.95ZM16.5 21.75H13.5V13.65H16.5V21.75Z"
        fill="#5890EC"
      />
    </svg>
  )
}

export default InfoIcon
